// extracted by mini-css-extract-plugin
export default {"root":"styles_root__4jcIk","checked":"styles_checked__-m-Zv","footer":"styles_footer__DI0Be","header":"styles_header__CN7xS","link":"styles_link__wMlM3"};